import { ref } from 'vue';
import { getSiteGlobals } from '@/utils/domainUtils';
import { type MieleStoredGlobals } from '@/types/shared-types';

export default function UseConfiguration(configOverrides?: MieleStoredGlobals) {
    const globalsConfig = ref<MieleStoredGlobals>();

    const loadConfig = async () => {
        // If we are passed a config, we don't need to load the globals
        if (configOverrides) {
            globalsConfig.value = configOverrides;
            return;
        }

        const data = await getSiteGlobals();
        if (data) {
            globalsConfig.value = data;
        }
    };

    return {
        globalsConfig,
        loadConfig,
    };
}
